import { FormTypes } from '~/data/forms/shared/interfaces/Form'

export type ticketStatusItem = {
  title: string
  formType: FormTypes
  buttonText: string
}

export enum TradingTicketStatus {
  sell = 'sell',
  owned = 'owned',
  buy = 'buy',
}

const ticketStatusMapper = (ticketStatus: TradingTicketStatus, t: any) => {
  switch (ticketStatus) {
    case TradingTicketStatus.sell:
      return {
        title: t('forSale'),
        formType: FormTypes.buy,
        buttonText: t('enquireToBuy'),
      } as ticketStatusItem
    case TradingTicketStatus.owned:
      return {
        title: t('inCollections'),
        formType: FormTypes.buy,
        buttonText: t('enquireToBuy'),
      } as ticketStatusItem
    case TradingTicketStatus.buy:
      return {
        title: t('wanted'),
        formType: FormTypes.sell,
        buttonText: t('enquireToSell'),
      } as ticketStatusItem
  }
}

export default ticketStatusMapper
